<template>
  <Teleport to="body">
    <!-- Modal -->
    <Transition name="modal">
      <div v-if="props.showSubscribe" class="modal-mask-subs">
        <div
          class="modal-container"
          :style="
            isMobile()
              ? 'width:95%'
              : reativeIsLoggedIn
              ? 'width:650px;'
              : 'width:1000px;'
          "
        >
          <div class="modal-body row justify-content-center">
            <div>
              <button
                type="button"
                @click="emit('showModalSubscribePlans', false)"
                aria-label="Close"
                style="
                  z-index: 10;
                  position: absolute;
                  font-size: 40px;
                  top: -10px;
                  right: 10px;
                "
              >
                x
              </button>
            </div>
            <div
              class="col-12 d-flex align-items-center justify-content-center left-text"
              :class="reativeIsLoggedIn ? 'col-lg-8' : 'col-lg-6 ctr-box'"
            >
              <div
                :class="`row justify-content-center my-5 ${
                  reativeIsLoggedIn ?? 'ps-lg-5'
                }`"
              >
                <div
                  class="text-center text1"
                  v-html="translate.textModalLogin1"
                ></div>
                <div
                  class="text-center text2"
                  v-html="translate.textModalLogin2"
                ></div>
                <div
                  class="text-center text3"
                  v-html="
                    reativeIsLoggedIn && !newUser
                      ? translate.textModalLogin3OldUser
                      : translate.textModalLogin3
                  "
                ></div>
                <div
                  class="text-center text5 mt-3"
                  @click="redirectPage('language-assine')">
                  <span class="text-assine">{{ translate.textModalLogin8 }}</span><br/>
                  {{ translate.textModalLogin9 }} {{ translate.textModalLogin10 }}
                  <img :src="hand" class="hand" />
                </div>
                <div class="div-or">
                  {{ route.params.language === "pt-br" ? 'ou' : 'or' }}
                </div>
                <div
                  class="text-center text4 mt-2"
                  @click="
                    redirectPage(
                      reativeIsLoggedIn && !newUser
                        ? 'language-assine'
                        : 'language-freetour'
                    )
                  "
                >
                  {{
                    reativeIsLoggedIn && !newUser
                      ? translate.textModalLogin7OldUser
                      : translate.textModalLogin7
                  }}
                </div>                
              </div>
            </div>
            <div
              class="col-lg-6 col-12 mb-5 justify-content-center"
              v-if="!reativeIsLoggedIn"
            >
              <div class="row d-flex align-items-center">
                <div
                  class="col header-text-1 d-flex justify-content-center mt-lg-5 mb-1"
                >
                  {{ translate.footer1ModalPlan }}
                  {{ translate.footer2ModalPlan }}
                </div>
              </div>
              <form @submit.prevent="getLogin">
                <div class="form-group row justify-content-center">
                  <div class="col-lg-9 col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="inputEmail"
                      aria-describedby="emailHelp"
                      :placeholder="translate2.placeHolderEmail"
                      name="email"
                      v-model="email"
                    />
                  </div>
                  <div class="col-10 input-group">
                    <input
                      v-if="hidden"
                      type="password"
                      class="form-control"
                      name="password"
                      id="inputPassword"
                      :placeholder="translate2.placeHolderPassword"
                      autocomplete="current-password"
                      v-model="password"
                    />
                    <input
                      v-if="!hidden"
                      type="text"
                      class="form-control"
                      name="password"
                      id="inputPassword2"
                      :placeholder="translate2.placeHolderPassword"
                      autocomplete="current-password"
                      v-model="password"
                    />
                    <i
                      @click="hiddenPassword"
                      class="input-group-text icon-eye"
                    ></i>
                  </div>
                  <div class="col-12 d-flex justify-content-center">
                    <span class="small">{{ translate2.forgotPwd1 }}</span
                    >&nbsp;
                    <span
                      class="small small-link"
                      @click="showModalForgotPassword(true)"
                      >{{ translate2.forgotPwd2 }}</span
                    >
                  </div>
                  <div class="col-12 text-center" v-if="loading">
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  <div class="col-12 d-flex justify-content-center" v-else>
                    <div class="d-w-btn mt-3">
                      <button>
                        {{ translate2.buttonLabel }}
                        <i class="icon-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
              <div class="row">
                <div class="col-12 mt-3">
                  <LoginSocialMedia
                    :redirect="false"
                    :size="isMobile() ? 200 : 240"
                    @returnMessage="returnMessage"
                    @closeModal="emit('showModalSubscribePlans', false)"
                    @isLoginUser="setIsLoginUser"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
  <ModalForgotPassword
    :showModalPwd="showModalPwd"
    @showModalForgotPassword="showModalForgotPassword"
    @showModalMessages="showModalMessages"
  />
  <ModalAccessRestricted
    :showModal="showRestrictedModal"
    :htmlContent="restrictedModalHtml"
    @close="showRestrictedModal = false"
  />
  <ModalMessages
    :options="optionsModal"
    @showModalMessages="showModalMessages"
  />
</template>

<script setup lang="ts">
import ModalMessages from "@/components/Modais/ModalMessages.vue";
import ModalForgotPassword from "@/components/Modais/ModalForgotPassword.vue";
import ModalAccessRestricted from "@/components/Modais/ModalAccessRestricted.vue";
import translaters from "@/tradutors/myaccount";
import api from "@/api";
import { corteLigado, funilErroDaApi, funilErroValidacao, funilLogin } from "@/utils/eventosDoFunil";
import { isMobile } from "@/shared/utils/mobile";
import LoginSocialMedia from "@/components/LoginSocialMedia.vue";
import translateModel from "@/tradutors/model";
import hand from 'assets/img/hand.png';

const router = useRouter();

const route = useRoute();
const storeUser = userStore();
const storeJwt = jwtStore();

const reativeIsLoggedIn = ref(storeUser.isLoggedIn ?? false);
const newUser = computed(() => storeUser.newUser);
const translate2 = computed(() =>
  route.params.language === "pt-br" ? translaters.portugues : translaters.ingles
);

const props = defineProps({
  showSubscribe: {
    type: Boolean,
    default: false,
  },
  plans: {
    type: Array,
  },
});

const translate = computed(() => {
  if (route.params.language === "pt-br") {
    return translateModel.portugues;
  } else {
    return translateModel.ingles;
  }
});

const emit = defineEmits(["showModalSubscribePlans"]);

const hidden = ref(true);
const password = ref("");
const email = ref("");
const loading = ref(false);
const optionsModal = ref({
  showModal: false,
  titleModal: "Erro",
  textBodyModal: "",
  textButtonModal: "",
});
const showModalPwd = ref(false);
const showRestrictedModal = ref(false);
const restrictedModalHtml = ref("");

function hiddenPassword() {
  hidden.value = !hidden.value;
}
interface IForm {
  email: string;
  password: string;
}
function checkForm(form: IForm) {
  if (!form.email) {
    error(
      route.params.language == "pt-br"
        ? "Email é obrigatório!"
        : "Email is required!"
    );
    return false;
  }
  if (!form.password) {
    error(
      route.params.language == "pt-br"
        ? "Senha é obrigatória!"
        : "Password is required!"
    );
    return false;
  }
  return true;
}
/** @param medido o erro veio da API e já foi classificado (erro_tipo) */
function error(value: string, medido = false) {
  showModalMessages({
    message: {
      show: true,
      title: "Erro",
      textButton: "Fechar",
      textBoby: value,
    },
  });
  // Depois do corte: erro sem a mensagem, classificado.
  if (corteLigado()) {
    if (!medido) funilErroValidacao("login", "formulario");
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "erro",
    erro: {
      tipo: value,
    },
  });
}
function showModalMessages({
  message,
}: {
  message: {
    show: boolean;
    title: string;
    textBoby: string;
    textButton: string;
  };
}) {
  optionsModal.value.showModal = message.show;
  optionsModal.value.titleModal = message.title;
  optionsModal.value.textBodyModal = message.textBoby;
  optionsModal.value.textButtonModal = message.textButton;
}
async function getLogin() {
  loading.value = true;
  let body = {
    email: email.value,
    password: password.value,
  };
  if (checkForm(body))
    await api
      .post("auth/login", body, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      })
      .then(async ({ data }) => {
        if (corteLigado()) {
          funilLogin("email");
        } else {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "login",
            login: { method: "email" },
          });
        }
        await storeUser.setUser(data.user);
        await storeJwt.setJwt(data.authorisation.token);
        if (data.newUser) await storeUser.setNewUser(data.newUser);

        let isActive = await storeUser.getActiveUser();
        if (isActive) window.location.reload();
        else reativeIsLoggedIn.value = true;
      })
      .catch(({ response }) => {
        if (response?.status === 423 && response?.data?.status === "restricted") {
          restrictedModalHtml.value = response.data.modal_html || "";
          showRestrictedModal.value = true;
          return;
        }
        const data = response?.data || {};
        funilErroDaApi("login", data, response?.status);
        if (data.errors) {
          let array: any = Array.from(
            Object.entries(data.errors),
            ([key, value]) => value
          );
          error(array[0][0], true);
        } else
          error(
            route.params.language == "pt-br"
              ? "Email ou Senha inválidos"
              : "Email or Password invalid",
            true
          );
      })
      .finally(() => {
        loading.value = false;
      });
  else loading.value = false;
}
function showModalForgotPassword(data: boolean) {
  showModalPwd.value = data;
}
function returnMessage(value: string) {
  error(value);
}
function redirectPage(name: string) {
  router.push({ name, params: { language: route.params.language } });
}

function setIsLoginUser() {
  reativeIsLoggedIn.value = storeUser.isLoggedIn;
}
</script>

<style scoped lang="css">
.modal-mask-subs {
  position: fixed;
  z-index: 9997;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
  overflow-y: auto;
}

.modal-container {
  margin: auto;
  padding: 0px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header {
  align-items: center;
  justify-content: end;
}

.modal-body {
  margin: 0;
}
.modal-default-button {
  float: right;
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.header-text-1 {
  font-family: "Exo-2";
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0;
  color: #5b5858;
}

.d-w-btn button {
  color: #fff;
  padding: 5px;
}

.d-w-btn {
  width: 130px;
  background: #000;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 11px;
  color: #ffffff;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
}

.form-group input {
  padding: 15px 20px;
  border-radius: 30px;
  margin-bottom: 15px;
  background-color: #f8f8f8;
  font-size: small;
}

.input-group {
  width: 75%;
}

.input-group-text {
  padding: 0;
  padding-left: 5px;
  font-size: 2rem;
  background-color: #f8f8f8;
  border: 1px solid #ced4da;
  border-radius: 30px;
  border-left-style: hidden;
  height: 52px;
}

#inputPassword2 {
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
}

.icon-eye:before {
  color: #ced4da;
  margin-right: 0.5em;
  cursor: pointer;
}

.small {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 13px;
  letter-spacing: 0;
  line-height: 15px;
}

.small-link {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 15px;
  text-decoration: underline;
  cursor: pointer;
}

.spinner-border {
  top: -5px;
}

.text1 {
  color: #ff6000;
  font-family: "Exo-2";
  font-weight: 400;
  font-size: 27.7px;
  letter-spacing: 0;
  line-height: 25px;
}

.text2 {
  color: #ff6000;
  font-family: "Exo-2";
  font-weight: 400;
  font-size: 32px;
  letter-spacing: 0;
  line-height: 35px;
}

.text3 {
  color: #8c8c8c;
  font-family: "Exo-2";
  font-weight: 700;
  font-size: 27px;
  letter-spacing: 0;
  line-height: 35px;
}

.text4 {
  background-color: #B5B5B5;
  color: #ffffff;
  font-family: "Exo-2";
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 1px;
  line-height: 20px;
  padding: 7px;
  border-radius: 14px;
  cursor: pointer;
  width: 300px;
  height: 40px;
  padding-top: 9px;
}
.text5 {
  background-color: #ff6000;
  color: #ffffff;
  font-family: "Exo-2";
  font-weight: 900;
  font-size: 15px;
  letter-spacing: -0.2px;
  line-height: 20px;
  padding: 7px 0px;
  border-radius: 14px;
  cursor: pointer;
  width: 300px;
  height: 72px;
}

.left-text {
  min-height: 440px;
}

.text-assine {
  font-family: 'Exo-2';
  font-weight: 900;
  font-size: 35px;
  line-height: 100%;
  text-align: center;
}

.hand {
  width: 30px;
  position: absolute;
  right: -23px;
  bottom: -5px;
}

.ctr-box {
  padding-left: 80px;
}

.div-or {
  font-family: 'Exo-2';
  font-weight: 400;
  font-size: 25px;
  text-align: center;
  color: #707070;
  height: 21px;
  line-height: 24px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {

  .modal-container {
    width: 70% !important;
  }  
  .input-group {
    width: 83.333333%;
  }

  .form-group input {
    padding: 8px 20px;
  }

  .input-group-text {
    height: 37px;
  }

  .d-w-btn {
    padding: 5px;
  }

  .left-text {
    min-height: 170px;
  }

  .ctr-box {
    padding-left: unset;
  }  
  .text1 {
    font-size: 17px;
    line-height: 24px;
  }
  .text2 {
    font-size: 20px;  
    line-height: 24px;    
  }
  .text3 {
    font-size: 17px;
    line-height: 24px;    
  }
  .text-assine {
    font-size: 25px;
  }
  .text5 {
    font-size: 12px;
    height: unset;     
    width: 200px;
  }
  .text4 {
    width: 200px;
    height: unset; 
    font-size: 14px;
  }
  .small {
    font-size: 11px;
  }
  .header-text-1 {
    font-size: 14px;
  }
  .div-or {
    font-size: 16px;
  }
}
</style>
